export const getToken = () => String(localStorage.getItem("token"))
export const getPermission = () => JSON.parse(localStorage.getItem("permissions"))
export const getIsAdmin = () => localStorage.getItem("is_admin") === "true"